import { Box, ButtonGroup, styled, ToggleButtonGroup } from "@mui/material";

export const StyledYearFilterBar = styled(Box)(({ theme }) => ({
  display: "flex",
  maxWidth: "100%",
  width: "90%",
  alignItems: "start",
  overflowX: "scroll",
  margin:"auto",
  ".toggleButtonGroup": {
    width: "100%",
    display: "flex",
    gap: "1rem",
    flex: "0",
    ".toggleButton": {
      border: "3px solid",
      borderColor: theme.color.main,
      width: "10rem",
      borderRadius: "25px",
      h4: {
        fontWeight: "bold",
      },
    },
  },
}));
